export enum withdrawalModals {
  PAYOUT = 'PAYOUT',
  BINDING_EMAIL = 'BINDING_EMAIL',
  VERIFICATION = 'VERIFICATION',
}
